import { render, staticRenderFns } from "./HubList.vue?vue&type=template&id=a20d0474&scoped=true&"
import script from "./HubList.vue?vue&type=script&lang=js&"
export * from "./HubList.vue?vue&type=script&lang=js&"
import style0 from "./HubList.vue?vue&type=style&index=0&id=a20d0474&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a20d0474",
  null
  
)

export default component.exports